import * as React from "react";
import { SvgIcon } from "./SvgIcon";
import { Warning_red, Warning_yield, Warning_stop } from "@icons";
import { Warning } from "./Warning";
import { FETCH_STATE, FETCH_STATE_INITIAL, FETCH_STATE_FETCHING, FETCH_STATE_ERROR } from "rd-redux-http";
import { EstimatedImpressionData } from "@store";
import { LoadingSpinner } from "./LoadingSpinner";
import { formatNumber } from "@common";
import * as cn from "classnames";
import "./EstimatedImpressionComponent.css";

const ErrorData = () => (
    <>
        <SvgIcon svg={Warning_red} />
        <Warning
            className="warning_red"
            title="Warning"
            text="Estimation not available in currently selected geography"
        />
    </>
);

const InsufficientData = () => (
    <>
        <SvgIcon svg={Warning_yield} />
        <Warning
            className="warning_yield"
            title="Warning"
            text="If you keep applying filters, your available inventory will be reduced."
        />
    </>
);

const NotEnoughData = () => (
    <>
        <SvgIcon svg={Warning_stop} />
        <Warning
            className="warning_stop"
            title="Stop"
            text="Reduce the amount of filters in settings, so you have more inventory available."
        />
    </>
);

export interface EstimatedImpressionsValueProps {
    estimatedImpressionFetchState: FETCH_STATE;
    estimatedImpression: EstimatedImpressionData;
    isReviewComponent: boolean;
    isSummaryComponent: boolean;
    canEstimate?: boolean;
}

export const EstimatedImpressionsValue = ({
    estimatedImpressionFetchState,
    estimatedImpression,
    isReviewComponent,
    isSummaryComponent,
    canEstimate
}: EstimatedImpressionsValueProps) => {
    const currentStatus = estimatedImpression && estimatedImpression.status;
    const isInitial: boolean = estimatedImpressionFetchState === FETCH_STATE_INITIAL ? true : false;
    const isLoading: boolean = estimatedImpressionFetchState === FETCH_STATE_FETCHING ? true : false;
    const isError: boolean = estimatedImpressionFetchState === FETCH_STATE_ERROR ? true : false;

    if ((isInitial || !canEstimate) && !isReviewComponent && !isSummaryComponent) {
        return (
            <span className="custom-initial-estimated-impression-value">
                Please set required fields, i.e. Dates, Budget, Language, and Country
            </span>
        );
    }

    if (isReviewComponent || isSummaryComponent) {
        return (
            <span className={cn("estimated-impression-value review__estimated")}>
                {isLoading ? (
                    <LoadingSpinner />
                ) : estimatedImpression && estimatedImpression.sizing ? (
                    <span>{formatNumber(estimatedImpression.sizing)}</span>
                ) : (
                    ""
                )}
                {isError ? (
                    <ErrorData />
                ) : currentStatus === "insufficient" ? (
                    <InsufficientData />
                ) : currentStatus === "not-enough-data" ? (
                    <NotEnoughData />
                ) : (
                    ""
                )}
            </span>
        );
    }

    return (
        <span className={cn("budget-value number-value custom-estimated-impression-value")}>
            {isError ? (
                <ErrorData />
            ) : currentStatus === "insufficient" ? (
                <InsufficientData />
            ) : currentStatus === "not-enough-data" ? (
                <NotEnoughData />
            ) : currentStatus === undefined || currentStatus === "sufficient" ? (
                <span>&nbsp;</span>
            ) : (
                ""
            )}
            {isLoading ? (
                <LoadingSpinner />
            ) : estimatedImpression && estimatedImpression.sizing ? (
                <span>{formatNumber(estimatedImpression.sizing)}</span>
            ) : (
                <span>-</span>
            )}
        </span>
    );
};
